import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { BiCalendar } from 'react-icons/bi';
import { Viewer } from 'src/components/cards';
import { APP_IMG } from 'src/constants';
import { IAds } from 'src/modules/ads';
import { DataContent, Related } from 'src/modules/cid/id';
import { getAffiliate } from 'src/utils/contents/get-affiliate';
import { getFeatureImage } from 'src/utils/contents/get-image';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useDateUpdate } from 'src/utils/helper';
import styled from 'styled-components';
import { KEY_ADS_POSITION } from '../ads/dynamicAds';

const WidgetSocialShare = dynamic(import('src/components/widgets/widget-social-share'));
const Carousels = dynamic(import('src/components/carousels'));
const CardV = dynamic(import('src/components/cards/card-v'));
const WidgetBreadcrumb = dynamic(import('src/components/widgets/widget-breadcrumb'));
const DynamicAds = dynamic(import('../ads/dynamicAds'));

type Props = {
  article: DataContent;
  _article: DataContent;
  countView: any;
  countViewCheck: number;
  related: Related[];
  dataAffiliate: any[];
  ads?: IAds[];
};

const ArticleAudio = ({ article, _article, countView, countViewCheck, related, dataAffiliate, ads }: Props) => {
  const router: any = useRouter();
  return (
    <>
      <ArticleWrapper>
        <div className='container' id='section-2'>
          <div className='article-area'>
            {/* ------------------------------- BREADCRUMB ------------------------------- */}
            <div className='breadcrumb-wrapper'>
              <WidgetBreadcrumb data={_article} />
            </div>
            {/* ----------------------------------- CONTENTS : HEADER ---------------------------------- */}
            <div className='post-info'>
              {article?.published_at && (
                <p className='date-time'>
                  <BiCalendar />
                  <span> {useDateUpdate(article?.published_at, true)} </span>
                </p>
              )}
              <div className='meta'>{countView >= countViewCheck && <Viewer data={countView} />}</div>
            </div>
            <div className='title-content'>
              <h1 className='category'>{article?.title}</h1>
            </div>
            <WidgetSocialShare
              articleLink={article?.link}
              // !DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                section: 'share',
                position: 'after:หัวข้อข่าว'
              }}
            />
            <div className='content-feature'>{getFeatureImage(article)}</div>
            {/* Ads-PPN BILLBOARD */}
            {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
            {/* ----------------------------------- CONTENTS : ARTICLE ---------------------------------- */}
            <div id='paragraph'>
              {article?.blurb && (
                /* ----------------------------------- CONTENTS : BLURB ---------------------------------- */
                <h2 className='content-blurb'>{article.blurb}</h2>
              )}
              {/* ------------------------- CONTENTS I : INARTICLE 1 ------------------------- */}
              {_article?.content_I && (
                <>
                  <div id='paragraph-1'>
                    <div
                      className='content-detail'
                      dangerouslySetInnerHTML={{
                        __html: _article?.content_I
                      }}
                    />
                    {_article?.is_show_ads && getAffiliate(1, dataAffiliate)}
                    {/* <!-- /223513049/adopthailand/thepeople_r_content_t_728x90_336x280 --> */}
                    {/* <div id='div-apt-ad-LTBWhLlDur' /> */}
                  </div>
                  {/* Ads-PPN INARTICLE-1 */}
                  {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}
                </>
              )}
              {/* ------------------------- CONTENTS II and ADS : INARTICLE 2 ------------------------ */}
              {_article?.content_II && (
                <>
                  <div id='paragraph-2'>
                    <div
                      className='content-detail'
                      dangerouslySetInnerHTML={{
                        __html: _article?.content_II
                      }}
                    />
                    {_article?.is_show_ads && getAffiliate(2, dataAffiliate)}
                    {/* <!-- /223513049/adopthailand/thepeople_r_content_m_728x90_336x280 --> */}
                    {/* <div id='div-apt-ad-wv32mDfCrx' /> */}
                  </div>
                  {/* Ads-PPN INARTICLE-2 */}
                  {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
                </>
              )}
              {/* -------------------------- CONTENTS III and ADS : INARTICLE 3 ----------------------- */}
              {_article?.content_III && (
                <div id='paragraph-3'>
                  <div
                    className='content-detail'
                    dangerouslySetInnerHTML={{
                      __html: _article?.content_III
                    }}
                  />
                  {_article?.is_show_ads && getAffiliate(3, dataAffiliate)}
                </div>
              )}
              {article?.bylineList && (
                <div className='row'>
                  {article?.bylineList.map((item, index) => (
                    <div className='byline col-12 col-md-4' key={index}>
                      <div className='byline-block'>
                        <a href={`/bylines/${item?.p_name}`}>
                          {!isEmpty(item?.image) ? (
                            <img loading='lazy' src={`${APP_IMG}${item?.image}`} alt='byline' className='img-byline' width='80' height='80' />
                          ) : (
                            <img loading='lazy' src={`${APP_IMG}/static/img-byline.png`} alt='byline' className='img-byline' width='80' height='80' />
                          )}
                        </a>
                        <div className='byline-content'>
                          <a href={`/bylines/${item?.p_name}`}>
                            <p className='byline-title'> {item?.p_name}</p>
                          </a>
                          {item?.description && (
                            <div
                              className='byline-desc'
                              dangerouslySetInnerHTML={{
                                __html: item?.description
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* {article?.byline && (
                <div className='byline'>
                  <Image
                  loading='lazy'
                  quality={75}
                  src={`${APP_IMG}/static/img-byline.png`}
                  alt='byline'
                  className='img-byline'
                  width='50'
                  height='50'
                />
                  <span> {article?.byline}</span>
                </div>
              )} */}
              <WidgetSocialShare
                articleLink={article?.link}
                // !DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'share',
                  position: 'after:paragraph-3'
                }}
              />
              {/* --------------------------- ADS : Native (Infinities) ----------------------------------- */}
              {_article.is_show_ads && <div id='section-ads'>{/* <div id='ADOP_V_3vsZsppzdJ' style={{ height: 0 }}></div> */}</div>}

              {/* ------------------------------ READ_COMPLETE ------------------------ */}
              <div id='read-complete' className='content-tags'>
                {!isEmpty(_article?.tags) && <span className='heading-tag'>แท็กที่เกี่ยวข้อง</span>}
                <div className='scroll-tag'>
                  {!isEmpty(_article?.tags) &&
                    _article.tags.map((item, index) => (
                      <a
                        key={index}
                        title={item}
                        href={`/tags/${item}`}
                        //! DATALAYER
                        onClick={() =>
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'แท็กที่เกี่ยวข้อง',
                            position: 'after:widget-share',
                            data: {
                              title: item,
                              heading: item,
                              index: index + 1
                            }
                          })
                        }
                      >
                        {item}
                      </a>
                    ))}
                </div>
              </div>
              {!isEmpty(related) && (
                <div className='related'>
                  <h2>
                    related
                    {/* {_article.subCategory?.en ||
                      _article.section?.en ||
                      'related'} */}
                  </h2>
                  <Carousels slideShow={4} mobileSlideShowTwo={1} mobileSlideShow={2} center={true} pauseOnHover={false} autoplaySpeed={6000}>
                    {related.map((item, i) => (
                      <div key={i} className={'card-item'}>
                        <CardV
                          data={item}
                          showTitle={true}
                          showBlurb={false}
                          showByline={false}
                          showTime={false}
                          showCountview={false}
                          external={false}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'ข่าวที่เกี่ยวข้อง',
                            position: 'after:แท็กที่เกี่ยวข้อง',
                            data: {
                              title: item?.title,
                              heading: 'ข่าวที่เกี่ยวข้อง',
                              carousel: i + 1
                            }
                          }}
                        />
                      </div>
                    ))}
                  </Carousels>
                </div>
              )}
            </div>
          </div>
        </div>
        {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />}
        {/* ----------------------------------- CONTENTS : End ---------------------------------- */}
      </ArticleWrapper>
    </>
  );
};

const ArticleWrapper = styled.div`
  position: relative;
  background-color: #000000;
  padding: 30px 0;
  margin-top: -30px;
  * {
    color: #fff;
  }
  .article-area {
    .content-blurb {
      margin-bottom: 30px;
      font-size: 32px;
      font-weight: 400;
      line-height: 1.4;
      @media (max-width: 480px) {
        font-size: 26px;
      }
    }
    .content-detail {
      * {
        font-family: 'Sarabun', sans-serif !important;
        color: inherit;
      }
      overflow: hidden;
      margin-bottom: 1rem;
      overflow: hidden;
      font-size: 18px;
      color: #fff;
      line-height: 2;
      span,
      p,
      em,
      strong,
      b,
      i {
        color: #fff;
      }
      picture {
        display: block;
        max-width: 80%;
        margin: 0px auto;
        width: 100%;
        @media (max-width: 768px) {
          max-width: 100%;
        }
      }
      ul,
      ol,
      * {
        li {
          margin-left: 1.5rem;
        }
      }
    }
    .post-info {
      display: flex;
      padding: 5px 0;
      .date-time {
        svg {
          fill: rgb(208, 23, 51);
          margin-right: 5px;
        }
        span {
          color:rgb(208, 23, 51) !important;
        }
        display: flex;
        align-items: center;
        @media (max-width: 480px) {
          font-size: 14px;
        }
      }
      .meta {
        margin-left: 5px;
        @media (max-width: 480px) {
          font-size: 14px;
        }
        svg {
          vertical-align: middle;
          fill: #ed1a3b;
        }
        span {
          color: #ed1a3b !important;
        }
      }
    }
    .title-content {
      @media (max-width: 480px) {
        margin: 15px 0;
      }
      h1 {
        line-height: 1.4;
        font-size: 48px;
        font-weight: 400;
        @media (max-width: 480px) {
          font-size: 26px;
        }
      }
    }
    .content-tags {
      font-size: 16px;
      margin-top: 30px;
      margin-bottom: 20px;
      .heading-tag {
        border-radius: 2px;
        padding: 4px 10px;
        border: 1px solid rgb(208, 23, 51);
        background-color:rgb(208, 23, 51);
        color: rgb(255, 255, 255);
        margin-right: 8px;
        font-weight: 600;
        margin-bottom: 15px;
      }
      .scroll-tag {
        min-height: 100px;
        overflow-y: scroll;
        margin-top: 25px;
        &::-webkit-scrollbar {
          width: 3px;
          border-radius: 10px;
          background-color: #000000;
        }

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #000000;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: rgb(237, 26, 59);
        }
      }
      a {
        display: inline-flex;
        border: 1px solid rgb(255, 255, 255);
        border-radius: 2px;
        padding: 4px 8px;
        color: rgb(255, 255, 255);
        margin: 5px 5px 0px 0px;
        &:hover {
          color: rgb(255, 255, 255);
          background-color: rgb(237, 26, 59);
          border: 1px solid rgb(237, 26, 59);
        }
      }
    }

    .content-feature {
      margin: 30px 0;
      .embed-responsive {
        iframe {
          display: block;
          position: relative !important;
          margin: auto !important;
          width: 100% !important;
          height: 675px;

          @media (max-width: 540px) {
            height: 210px;
          }
        }
      }
    }
  }

  .byline {
    margin: 0px 0 30px 0;
    .byline-block {
      padding: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      border-radius: 30px;
      background: linear-gradient(85deg, #434343, #262626);
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    }
    .img-byline {
      width: 80px;
      aspect-ratio: 1/1;
      /* max-width: 100%; */
      border-radius: 100%;
      object-fit: cover;
      object-position: top;
    }
    .byline-content {
      margin-left: 15px;
      p {
        color: #fff;
      }
      .byline-title {
        font-size: 16px;
      }
      .byline-desc {
        margin-top: 12px;
        p {
          font-size: 14px;
          &:not(:last-child) {
            margin-bottom: 5px;
          }
        }
      }
    }
  }

  /* related */
  .related {
    .related-carousels {
      display: block !important;
      width: 50% !important;
      max-width: 100%;
      margin: auto;
    }
    h2 {
      text-transform: uppercase;
    }
    .slick-slider {
      margin: 0 -10px;
    }
    .card-item {
      padding: 0 10px;
      img {
        margin-top: unset;
      }
      h3 {
        color: #fff;
      }
    }
  }

  /* cookie sticky */
  #cookie {
    position: sticky;
    bottom: 0;
  }
`;

export default ArticleAudio;
